import React from 'react';
import { useForm } from 'react-hook-form';
import { injectIntl } from '../../utils/reactIntl';
import {
  Button,
  FieldCheckbox,
} from '../../components';
import './event.global.scss';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  intl: any;
  handleFormSubmit: any,
  handleCloseModal: any,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const ExportEventInfoForm: React.FC<Props> = (props: Props) => {
  const {
    intl,
    handleFormSubmit,
    handleCloseModal,
  } = props;
  const formProps = useForm();

  return (
    <form className="filterForm" onSubmit={formProps.handleSubmit(handleFormSubmit)}>
      <FieldCheckbox
        id="event-participants"
        name="event-participants"
        formProps={formProps}
        className="radioColumn"
        label="Participants Detail"
      />
      <FieldCheckbox
        id="event-report-user"
        name="event-report-user"
        formProps={formProps}
        className="radioColumn"
        label="Event Report Detail"
      />
      <FieldCheckbox
        id="notification"
        name="notification"
        formProps={formProps}
        className="radioColumn"
        label="Event Notification"
      />
      <FieldCheckbox
        id="detail"
        name="detail"
        formProps={formProps}
        className="radioColumn"
        label="Event Details"
      />
      <div className="buttonWrapper">
        <Button
          onClick={handleCloseModal}
        >
          {intl.formatMessage({ id: 'ExportUserInfo.button.cancel' })}
        </Button>
        <Button
          buttonType={ButtonTypes.submit}
        >
          {intl.formatMessage({ id: 'ExportUserInfo.button.export' })}
        </Button>
      </div>
    </form>
  );
};

export default injectIntl(ExportEventInfoForm);
